import { render, staticRenderFns } from "./supportHistory.vue?vue&type=template&id=13e5950a&"
import script from "./supportHistory.vue?vue&type=script&lang=js&"
export * from "./supportHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports